export enum IrisXHeadersEnum {
  SERVICE_NAME = 'x-iris-service-name',
  BROWSER_RESOLUTION_WIDTH = 'x-iris-browser-resolution-width',
  BROWSER_RESOLUTION_HEIGHT = 'x-iris-browser-resolution-height',
  AZURE_TOKEN = 'x-iris-azure-token',
  REQ_ID = 'x-iris-req-id',
  RESPONSE_TIME = 'x-iris-response-time',
  APP_NAME = 'x-iris-application-name',
}
